export default "__VITE_ASSET__$G4dvE1W__"